import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

interface LogsModalProps {
  jobId: string;
  jobName: string;
}

const ViewLogsButtonCell: FC<LogsModalProps> = ({ jobId, jobName }) => {
  const projectId = +useParams().projectid!;
  const dispatch = useAppDispatch();

  return (
    <CustomButton
      buttonType="borderless"
      label="View"
      onClick={() => dispatch(openModal({ type: ModalTypesEnum.JOB_LOGS, payload: { projectId, jobId, jobName } }))}
    />
  );
};

export default ViewLogsButtonCell;
